import CompareProduct from "@components/Icons/CompareProduct";
import Heart from "@components/Icons/Heart";
import { productHelper } from "@lib/helpers";
import { addToCompare, removeFromCompare } from "@store/catalog/actions";
import { addToWishlist, deleteFromWishlist } from "@store/wishlist/actions";
import classNames from "classnames";
import { connect } from "react-redux";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

// Favorite/Compara: bricostore uses pills (rounded-full) like add-to-cart; altex/MG keep the diagonal radius
const WISH_COMPARE_RADIUS = isBricoStore
  ? "rounded-full"
  : "rounded-tr rounded-bl";

// Brico: red palette (was blue #1D4ED8); altex/MG keep the blue
const WC_BORDER = isBricoStore ? "border-red-brand" : "border-[#1D4ED8]";
const wcSelected = isBricoStore
  ? "bg-red-brand text-white"
  : "bg-[#1D4ED8] text-white";
const wcUnselected = isBricoStore
  ? "bg-white text-red-brand"
  : "bg-white text-[#1D4ED8]";

const ProductPageWishlistAndCompare = ({
  addToCompare,
  removeFromCompare,
  addToWishlist,
  deleteFromWishlist,
  wishlistProductsList,
  compareProductsList,
  product,
  user,
}) => {
  const { isWestaco, isVirtualService } = productHelper(product);

  if (user.customer?.sales_consultant_id || isWestaco || isVirtualService) {
    return null;
  }

  const isInCompare = Boolean(
    compareProductsList.find(
      (compareProduct) => compareProduct.sku === product.sku
    )
  );

  const isInWishlist = Boolean(wishlistProductsList?.includes(product.sku));

  return (
    <>
      <button
        className={classNames(
          `flex items-center justify-center gap-[4px] w-full border ${WC_BORDER} ${WISH_COMPARE_RADIUS} text-[14px] py-[8px] px-[16px]`,
          {
            [wcSelected]: isInWishlist,
            [wcUnselected]: !isInWishlist,
          }
        )}
        data-test="WISHLIST_BUTTON"
        onClick={() =>
          isInWishlist ? deleteFromWishlist(product) : addToWishlist(product)
        }
      >
        <Heart width="20px" height="20px" /> Favorite
      </button>

      <button
        className={classNames(
          `flex items-center justify-center gap-[4px] w-full border ${WC_BORDER} ${WISH_COMPARE_RADIUS} text-[14px] py-[8px] px-[16px]`,
          {
            [wcSelected]: isInCompare,
            [wcUnselected]: !isInCompare,
          }
        )}
        data-test="COMPARE_BUTTON"
        onClick={() =>
          isInCompare
            ? removeFromCompare(product.sku)
            : addToCompare(product.sku)
        }
      >
        <CompareProduct width="20px" height="20px" /> Compara
      </button>
    </>
  );
};

export default connect(
  (state) => ({
    user: state.user,
    wishlistProductsList: state.wishlist.productsAll,
    compareProductsList: state.catalog.compare,
  }),
  {
    addToCompare,
    removeFromCompare,
    addToWishlist,
    deleteFromWishlist,
  }
)(ProductPageWishlistAndCompare);
